export const css = {
	root: '_3lBb6LYa',
	slideIn: 'Z5mt9ZLS',
	slideOut: '_3Y90SzDf',
	underlayVisible: '_21rFZX09',
	content: '_3helo1W-',
	pane: 'ZGj1Cw_d',
	title: '_1OuBu9oo',
	titleContent: '_2h7PMacr',
	close: '_3FKNJT1w',
	closeIcon: '_1NEh1cpd',
	left: 'si8A2y7a',
	right: 'imrHPs4t',
	top: '_3stKkSt1',
	bottom: '_3pfFVW10',
	open: '_2YqtEF3u',
	' _key': 'afcpe-theme/afcpe/base-widgets/sliding-pane'
};

export default css;
